import script from "./ProjectListItemParameter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectListItemParameter.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectListItemParameter.vue?vue&type=style&index=0&id=1a94c847&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a94c847"]])

export default __exports__